import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { color } from "src/styles/variables";

function AddressPreview({ item, onClick }) {
  if (item.Description && item.Type === "Street") {
    const [, description, addressCount] =
      item.Description.match(/(.+)-\s([0-9]+\sAddresses)/) || [];

    if (description && addressCount) {
      return (
        <div>
          {description} <wbr />
          <strong> - {addressCount}</strong>
        </div>
      );
    }
  }

  return (
    <Wrapper role="button" tabIndex={0} onClick={onClick} onKeyPress={onClick}>
      {item.Description ? (
        <div>
          {item.Text}, <wbr />
          {item.Description}
        </div>
      ) : (
        <div>{item.Text}</div>
      )}
    </Wrapper>
  );
}

AddressPreview.propTypes = {
  item: PropTypes.shape({
    Text: PropTypes.string.isRequired,
    Description: PropTypes.string,
    Type: PropTypes.string,
  }).isRequired,
  onClick: PropTypes.func.isRequired,
};

export default AddressPreview;

const Wrapper = styled.div`
  padding: 10px;
  margin: 10px 0;
  border: 1px solid ${color.darkGrey};
  border-radius: 5px;
  font-size: 14px;
  cursor: pointer;
  :hover {
    border-color: ${color.midBlue};
    background: ${color.midBlue};
    color: ${color.white};
  }
`;
